var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3341_19695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0001 40.61L16.1201 40.61C16.1201 52.4369 25.5127 62.0287 37.0976 62.0287L38.452 62.0287L42.3985 61.9612C53.3406 61.2347 62.0025 51.9662 62.0001 40.61Z",
    fill: "#3388FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.27 22.4248L28.2149 61.4799C27.9812 61.7136 27.664 61.8443 27.3335 61.8431L1.14561 61.7478C0.46255 61.7453 -0.0898714 61.1909 -0.0898714 60.5078L-0.0898724 37.9899C-0.0898725 37.1677 0.236734 36.3792 0.818094 35.7979L40.956 -4.34003",
    fill: "#003C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 3.1C62 1.38792 60.6121 0 58.9 0H37.2C20.0792 0 6.2 13.8792 6.2 31V37.51C6.2 39.2221 7.58792 40.61 9.3 40.61H62V3.1Z",
    fill: "#1760CE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_3341_19695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7258 4.85009C37.5653 13.5157 43.5418 24.7895 51.9258 41.6369C52.2526 42.2924 52.0521 43.22 51.4094 43.5704C46.7608 46.1071 40.4519 49.5921 28.8421 53.6487C28.7007 53.6981 28.5427 53.6665 28.3944 53.6459C27.7325 53.558 24.99 53.1388 23.2144 52.6689C22.6747 52.526 22.1734 52.2676 21.9029 51.7784L3.63124 18.8681C3.32363 18.3143 3.33736 17.6368 3.66833 17.0968L6.20068 12.9523L30.6466 4.13689C31.4212 3.8593 32.3248 4.13139 32.7258 4.85009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5859 8.49988L38.4744 21.2179L18.7855 29.2473L11.7131 15.9438L31.5859 8.49988Z",
    fill: "#1760CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45707 16.9662C8.45707 16.9662 15.3785 29.7406 24.6221 46.5331C24.6207 46.5331 17.8174 35.8612 8.45707 16.9662Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4283 32.9067L35.2857 30.8729C35.6674 30.7122 35.8281 30.2559 35.6276 29.8932L34.2049 27.2973C34.0346 26.9881 33.6611 26.8535 33.3328 26.9854L28.4357 28.9477C28.047 29.103 27.8823 29.5647 28.0828 29.9316L29.5453 32.6003C29.7197 32.9109 30.1001 33.0441 30.4283 32.9067Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4034 29.9866L41.3461 28.3348C41.721 28.1782 41.8831 27.7329 41.6977 27.3715L40.3958 24.8375C40.231 24.5174 39.8506 24.3744 39.5155 24.5077L35.4588 26.1334C35.0688 26.29 34.904 26.7518 35.1073 27.1201L36.5231 29.6802C36.6948 29.9921 37.0752 30.124 37.4034 29.9866Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.329 29.7901L21.1284 31.8734C20.7397 32.0287 20.5749 32.4904 20.7768 32.8587L22.3012 35.6345C22.4728 35.9478 22.8532 36.0798 23.1828 35.9423L28.3382 33.7835C28.7199 33.6227 28.8806 33.1665 28.6801 32.8037L27.2011 30.1048C27.0308 29.7929 26.6572 29.6596 26.329 29.7901Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6204 39.7749L26.4609 41.9351C26.1313 42.0725 25.7509 41.9406 25.5793 41.6273L24.0494 38.8363C23.8503 38.4722 24.011 38.0146 24.3941 37.8551L29.5618 35.7114C29.8914 35.5754 30.2704 35.7087 30.4407 36.0206L31.9609 38.7951C32.1628 39.1579 32.0035 39.6141 31.6204 39.7749Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5691 36.8644L33.7118 38.8982C33.3822 39.0356 33.0018 38.9037 32.8301 38.5904L31.314 35.8228C31.1149 35.4586 31.2756 35.001 31.6587 34.8416L36.5243 32.8229C36.8539 32.6869 37.2329 32.8202 37.4032 33.1321L38.911 35.8846C39.1115 36.2474 38.9522 36.7036 38.5691 36.8644Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.673 35.9835L44.7023 34.296C45.0841 34.1366 45.2434 33.6818 45.0456 33.319L43.5583 30.5816C43.388 30.2669 43.0076 30.1336 42.6781 30.2697L38.6323 31.9475C38.2492 32.1069 38.0885 32.5632 38.2876 32.9287L39.7914 35.6757C39.9631 35.9876 40.3435 36.1209 40.673 35.9835Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.763 41.593L47.7565 39.8244C48.1287 39.6595 48.2825 39.2115 48.0875 38.8528L46.7719 36.4274C46.6016 36.1141 46.2239 35.9794 45.8944 36.1141L41.828 37.7755C41.4421 37.9335 41.2801 38.3925 41.4792 38.758L42.8676 41.2906C43.0434 41.6081 43.432 41.74 43.763 41.593Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.726 41.494L27.3907 43.6735C26.9938 43.8357 26.8359 44.3152 27.0584 44.6822L28.7984 47.5528C28.9796 47.8524 29.3573 47.972 29.6773 47.829L34.7502 45.5822C35.1196 45.4187 35.2734 44.9762 35.0853 44.6176L33.6076 41.8129C33.4387 41.4968 33.0583 41.358 32.726 41.494Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.876 44.6422L41.6825 42.5136C42.0561 42.3487 42.2085 41.898 42.0121 41.5393L40.5921 38.949C40.4219 38.6384 40.0442 38.5038 39.716 38.6384L34.8367 40.6324C34.4508 40.7904 34.2887 41.2494 34.4879 41.6149L35.9806 44.3399C36.1564 44.6573 36.5437 44.7893 36.876 44.6422Z",
    fill: "#EEF0F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.401 50.267H46.9856M46.9856 50.267L51.1933 54.4747M46.9856 50.267L51.1933 46.0593",
    stroke: "#EA7A7A",
    strokeWidth: 1.68308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7285 40.1685L46.1439 40.1685M46.1439 40.1685L41.9362 35.9608M46.1439 40.1685L41.9362 44.3762",
    stroke: "#EA7A7A",
    strokeWidth: 1.68308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_3341_19695",
    x: 1.40991,
    y: 3.03003,
    width: 52.6704,
    height: 54.645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0588235 0 0 0 0 0.0784314 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3341_19695"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0588235 0 0 0 0 0.0784314 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3341_19695",
    result: "effect2_dropShadow_3341_19695"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0588235 0 0 0 0 0.0784314 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3341_19695",
    result: "effect3_dropShadow_3341_19695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_3341_19695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3341_19695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "matrix(-1 0 0 1 62 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.c270262f.svg";
export { ForwardRef as ReactComponent };